var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 35,
    height: 24,
    transform: "translate(0.001 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(-1252 -2940)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(1252 2940)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(1267.478 2961.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(-0.478 -0.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M33.592,18.27a3.007,3.007,0,0,0-.372-4.57,3.007,3.007,0,0,0-.547-4.378,3.007,3.007,0,0,0-.547-4.378A3.01,3.01,0,0,0,29.822,0H15.994a3.024,3.024,0,0,0-1.881.659L12.2,2.189H9.3V1.368A.821.821,0,0,0,8.481.547H4.1a.821.821,0,0,0-.821.821v.821H.821a.821.821,0,1,0,0,1.642H3.283V5.492a1.918,1.918,0,0,0-1.642,1.9v6.566a1.918,1.918,0,0,0,1.642,1.9V17.51H.821a.821.821,0,1,0,0,1.642H3.283v.821a.821.821,0,0,0,.821.821H8.481a.821.821,0,0,0,.821-.821v-.821h2.82l3.888,4.374a1.642,1.642,0,0,0,1.227.551h13.68a.821.821,0,0,0,.816-.73,7.125,7.125,0,0,0-.864-4.194h.6a2.99,2.99,0,0,0,2.128-.881M4.925,2.189H7.661V5.472H4.925Zm-1.642,5.2a.274.274,0,0,1,.274-.274H9.029a.274.274,0,0,1,.274.274v6.566a.274.274,0,0,1-.274.274H3.557a.274.274,0,0,1-.274-.274ZM7.661,19.152H4.925V15.869H7.661Zm21.648.658a4.322,4.322,0,0,1,.813,2.625H17.237L13.1,17.786a.832.832,0,0,0-.613-.275H9.3V15.849a1.918,1.918,0,0,0,1.642-1.9V7.387A1.918,1.918,0,0,0,9.3,5.492V3.83H12.49A.82.82,0,0,0,13,3.65l2.136-1.709a1.374,1.374,0,0,1,.855-.3H29.822a1.368,1.368,0,0,1,0,2.736h-3.01a.821.821,0,1,0,0,1.642h3.557a1.368,1.368,0,1,1,0,2.736H27.223a.821.821,0,0,0,0,1.642h3.694a1.368,1.368,0,1,1,0,2.736H27.633a.821.821,0,0,0,0,1.642h3.83a1.368,1.368,0,1,1,0,2.736h-9.3a.821.821,0,1,0,0,1.642h5.472a2.118,2.118,0,0,1,1.675.658",
    transform: "translate(0.397 0.251)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(-0.478 -0.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M49.38,93.589a.82.82,0,0,0,.58.24l.058,0a.819.819,0,0,0,.6-.326l1.642-2.189a.821.821,0,1,0-1.313-.985l-1.074,1.431-.425-.425A.821.821,0,0,0,48.286,92.5Z",
    transform: "translate(-43.271 -81.541)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group2.e911b53aa1dead32b5d0668106870fb9.svg";
export { ForwardRef as ReactComponent };